<template>
  <div class="flex flex-dir-column app-layout orver-hidden-x" v-loading="queryLoading">
    <!-- 顶部搜索的表单 -->
    <div class="top-search padding-left-10 padding-right-10">
      <el-form
        align="left"
        size="mini"
        ref="topForm"
        :model="formQuery"
        label-width="0"
        :inline="true"
        class="flex flex-wrap"
      >
        <!-- <Version
          :os.sync="formQuery.os"
          :osVersion.sync="formQuery.osVersion"
          :osVersionList.sync="osVersionList"
          @update="queryUserCount"
        /> -->
        <el-form-item label="平台应用" label-width="70px">
          <system-select
            size="mini"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formQuery.range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            unlink-panels
            :clearable="false"
            @change="queryUserCount"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-card
      class="flex-1 box-card box-card-echart"
      shadow="never"
    >
      <!-- 顶部各种总数据，还未传参 -->
      <el-row :gutter="20">
        <!-- 用户TOP -->
        <el-col :span="24">
          <el-card class="box-card" shadow="never">
            <div class="box-chart padding-top-20">
              <div class="title">新增趋势
              </div>
              <Echart
                :height="500"
                :id="'chartUserLine'"
                :data="chartDataUserLine"
                showData
                isMountedRender
                :isShowAreaStyle="false"
                :islinePlie="true"
              />
              <!-- <div class="box-chart-footer">
                <el-select
                  size="mini"
                  v-model="osVersionSelect"
                  multiple
                  placeholder="版本对比"
                >
                  <el-option
                    v-for="item in osVersionList"
                    :key="item.os"
                    :label="item.os"
                    :value="item.value === undefined ? item.os : item.value">
                  </el-option>
                </el-select>
              </div> -->
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- <div class="event-table flex-1 flex flex-column">
        <el-table
          max-height="300px"
          :data="tableData"
          v-loading="queryLoading"
          size="mini"
          stripe
        >
          <el-table-column
            v-for="(item, index) in columnsList"
            :width="item.width"
            :min-width="item.minWidth"
            :label="item.label"
            :prop="item.prop"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
          />
        </el-table>
        <el-row class="padding-20">
          <el-col align="right">
            <el-pagination
              class="analyze-users-pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableQuery.pageNum"
              :page-sizes="[20, 50, 100, 200, 300, 400]"
              :page-size="tableQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableQuery.total"
            ></el-pagination>
          </el-col>
        </el-row>
      </div> -->
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import { queryUserCount } from '@/api/analyze';
import Echart from '@/views/components/echart/index.vue';
// import Version from '../components/version.vue';

export default {
  components: {
    Echart,
    // Version,
  },
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel']),
  },
  data() {
    return {
      osVersionList: [],
      osVersionSelect: [],
      chartDataUserLine: {
        x: [0],
        y: [{ name: '总用户', data: [0] }, { name: '新增用户', data: [0] }],
      },
      formQuery: {
        range: [],
        osVersion: '',
        eventCode: '',
        os: '',
      },
      tableQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      pageEvents: [],
      queryLoading: false,
      tableData: [],
      columnsList: [
        {
          label: '版本号',
          prop: 'version',
        },
        {
          label: '总用户',
          prop: 'total',
        },
        {
          label: '新增用户',
          prop: 'added',
        },
        {
          label: '新增用户占比',
          prop: 'scale',
        },
      ],
    };
  },
  mounted() {
    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryUserCount();
  },
  watch: {
    source: {
      handler() {
        this.queryUserCount();
      },
    },
    bizChannel: {
      handler(val, old) {
        if (val !== old && this.source === '') {
          this.queryUserCount();
        }
      },
    },
  },
  methods: {
    // async queryTableData(currentPageNum) {
    //   if (currentPageNum) {
    //     this.tableQuery.pageNum = currentPageNum;
    //   }
    //   try {
    //     this.queryLoading = true;

    //     // eslint-disable-next-line object-curly-newline
    //     const { pageNum, pageSize } = this.tableQuery;

    //     const params = {
    //       pageNum,
    //       pageSize,
    //     };

    //     const {
    //       data: { list, total },
    //     } = await queryUserList(params);
    //     this.tableQuery.total = total;
    //     this.tableData.splice(0, this.tableData.length, ...list);
    //   } finally {
    //     this.queryLoading = false;
    //   }
    // },
    // handleSizeChange(size) {
    //   this.tableQuery.pageSize = size;
    //   this.tableQuery.pageNum = 1;
    //   this.queryTableData();
    // },
    // handleCurrentChange(num) {
    //   this.tableQuery.pageNum = num;
    //   this.queryTableData();
    // },
    resetChartData(data = []) {
      const { range } = this.formQuery;
      const analyzeTimeTo = Moment(range[1]).format('YYYY-MM-DD');
      const analyzeTimeFrom = Moment(range[0]).format('YYYY-MM-DD');
      // eslint-disable-next-line operator-linebreak
      const days =
        Moment(analyzeTimeTo).diff(Moment(analyzeTimeFrom), 'days') + 1;

      const xList = [];
      const yList = [{ name: '总用户', data: [] }, { name: '新增用户', data: [] }];
      // 计算相差多少天
      for (let i = 0, len = days; i < len; i++) {
        const time = Moment(analyzeTimeFrom).add(i, 'days').format('YYYY-MM-DD');
        xList.push(time);
        if (data.length) {
          // 根据时间节点，搜索出对应数据
          const [{
            newUser,
            userTotal,
          }] = data.filter(({ analyzeTime }) => analyzeTime.indexOf(time) !== -1);

          yList[0].data.push(userTotal || 0);
          yList[1].data.push(newUser || 0);
        } else {
          yList[0].data.push('暂无数据');
          yList[1].data.push('暂无数据');
        }
        // yList[i].data.push(0);
      }

      this.chartDataUserLine.x.splice(0, this.chartDataUserLine.x.length, ...xList);
      this.chartDataUserLine.y.splice(0, this.chartDataUserLine.y.length, ...yList);
    },
    async queryUserCount() {
      this.queryLoading = true;
      try {
        const { range } = this.formQuery;
        const analyzeTimeTo = `${Moment(range[1]).format('YYYY-MM-DD')} 23:59:59`;
        const analyzeTimeFrom = `${Moment(range[0]).format('YYYY-MM-DD')} 00:00:00`;

        const {
          data,
        } = await queryUserCount({
          analyzeTimeTo,
          analyzeTimeFrom,
        });

        this.resetChartData(data);
      } catch (error) {
        console.error(error);
        this.resetChartData();
      } finally {
        this.queryLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  border: 0;
  text-align: left;
  margin-bottom: 20px;
  &::v-deep {
    .el-card__body {
      padding-top: 0;
    }
  }
  &-echart {
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.app-layout {
  height: calc(100vh - 0);
  min-width: 800px;
  margin: 15px 0 0;
}
// .top-search {
//   position: fixed;
//   top: 95px;
//   left: 15px;
//   right: 15px;
//   padding: 30px 20px 0;
//   background: #fff;
//   z-index: 99;
//   text-align: left;
//   border-radius: 5px;
// }
.box-chart {
  .title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-footer {
    margin-top: -40px;
  }
}
</style>
